import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import IconButton from '@mui/material/IconButton'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Text } from '../../components/1elements'

const NamedListItem = ({ user, index, deleteHandler, disabled }) => {
  const classes = useStyles()

  const userName = user.name

  const primaryContent = <Text type='detailNameDetailsHeader'>{userName}</Text>

  return (
    <Fragment key={index}>
      <ListItem alignItems='flex-start' className={classes.listItem}>
        <ListItemText primary={primaryContent} />

        {deleteHandler && !disabled && (
          <ListItemSecondaryAction>
            <IconButton
              edge='end'
              aria-label='delete'
              className={classes.deleteButton}
              onClick={index => deleteHandler(index)}
            >
              <HighlightOffIcon />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
      <Divider variant='fullWidth' />
    </Fragment>
  )
}

export default React.memo(NamedListItem)

const useStyles = makeStyles({
  listItem: {
    padding: '0 auto',
    margin: '0',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    '& .MuiListItemText-secondary': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  deleteButton: {
    padding: '12px 0'
  },
  smImage: {
    width: 50,
    height: 50,
    '& img': {
      transform: 'scale(0.6)'
    }
  }
})
